import LottieIllustration from '../../app/components/lottieIllustration';
import personLottieData1 from '../../../assets/lottie/finish-croud/1/data.json';
import personLottieData2 from '../../../assets/lottie/finish-croud/2/data.json';
import personLottieData3 from '../../../assets/lottie/finish-croud/3/data.json';
import personLottieData4 from '../../../assets/lottie/finish-croud/4/data.json';
import personLottieData5 from '../../../assets/lottie/finish-croud/5/data.json';

export default class FinishCroudView {
    #wrapEl;
    #options;
    #personEls;
    #lottieArray;
    #lottieData = [personLottieData1, personLottieData2, personLottieData3, personLottieData4, personLottieData5];

    constructor(selector, options = {}) {
        this.#options = options;
        this.#wrapEl = document.querySelector(selector);
        this.#personEls = Array.from(this.#wrapEl.querySelectorAll('.js-croud-person'));

        this.initLottie();
    }

    initLottie() {
        this.#lottieArray = [];

        this.#personEls.forEach((personEl, index) => {
            const personLottie = new LottieIllustration(personEl, {
                animationData: this.#lottieData[index],
                loop: true,
                autoplay: false
            });

            this.#lottieArray.push(personLottie);
        });
    }

    show(isPt) {
        this.#wrapEl.classList.add('active');

        this.#lottieArray.forEach((lottie, index) => {
            if (isPt && index >= 3) return;

            lottie.play();
        });
    }

    hide() {
        this.#wrapEl.classList.remove('active');

        this.#lottieArray.forEach((lottie) => {
            lottie.stop();
        });
    }
}
